import React, { Component } from 'react'
import moment from 'moment-timezone'
import service from '../services'
import LoaderSvg from '../assets/images/loader.svg'
import refresh from '../assets/images/refresh.png'

let historySub;

export default class ReceiptModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expandedRows: {},
            viewHistoryPopup: false,
            historyData: null,
            historyLoading: false,
            refreshing: false,
        }
        this.apiserve = new service()
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.purchaseList !== this.props.purchaseList) {
            this.setState({ refreshing: false })
        }
    }

    componentDidMount = () => {
        historySub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case 'admin|viewUserHistory':
                    if (!response.error) {
                        this.setState({ viewHistoryPopup: true, historyData: response.data, historyLoading: false })
                    } else {
                        this.apiserve.error(response.data.error)
                        this.setState({ historyLoading: false })
                    }
                    break;
                default:
                    break;
            }
        })
    }

    componentWillUnmount = () => {
        historySub.unsubscribe()
    }

    val = (v) => (v !== undefined && v !== null && v !== '') ? v : '-'

    toggleRow = (orderId) => {
        this.setState(prev => ({
            expandedRows: {
                ...prev.expandedRows,
                [orderId]: !prev.expandedRows[orderId]
            }
        }))
    }

    handleRefresh = () => {
        if (this.props.onRefresh) {
            this.setState({ refreshing: true })
            this.props.onRefresh()
        }
    }

    viewHistory = (type, id) => {
        const data = type === 'ticket' ? { ticketId: id } : { passId: id }
        this.setState({ historyLoading: true })
        this.apiserve.sendevent('admin|viewUserHistory', data)
    }

    closeHistoryPopup = () => {
        this.setState({ viewHistoryPopup: false, historyData: null })
    }

    getChildItems = (item) => {
        if (item.tickets && item.tickets.length > 0) return { type: 'ticket', items: item.tickets }
        if (item.passes && item.passes.length > 0) return { type: 'pass', items: item.passes }
        return null
    }

    renderHistoryRows = (historyData) => {
        const pendingData = historyData && historyData.pendingData && historyData.pendingData.is_pending_transfer ? historyData.pendingData : null
        const rows = pendingData
            ? [pendingData]
            : Array.isArray(historyData) ? historyData
            : Array.isArray(historyData && historyData.history) ? historyData.history
            : []

        if (!rows.length) return <p className="no_purchase">No history found.</p>

        return (
            <table>
                <thead>
                    <tr>
                        <th>From Person</th>
                        <th>To Person</th>
                        <th>Transfer Date</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((entry, i) => (
                        <tr key={i}>
                            <td>{entry.fromName ? `${entry.fromName} (${entry.fromEmail})` : this.val(entry.fromEmail)}</td>
                            <td>{entry.toName ? `${entry.toName} (${entry.toEmail})` : this.val(entry.toEmail)}</td>
                            <td>{entry.created_at ? `${moment(entry.created_at).tz("US/Mountain").format('MMM DD YYYY h:mm A')} MT` : '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }

    renderChildRows = (item) => {
        const child = this.getChildItems(item)
        if (!child) return null

        if (child.type === 'ticket') {
            return child.items.map((ticket, i) => (
                <tr key={ticket.id || i} className="ph_child_row">
                    <td className="ph_child_id">{this.val(ticket.id)}</td>
                    <td>{ticket.created_at ? `${moment(ticket.created_at).tz("US/Mountain").format('MM/DD/YYYY h:mm A')} MT` : '-'}</td>
                    <td>
                        {ticket.event ? ticket.event.name : '-'}
                        {ticket.ticket_bucket ? ` (${ticket.ticket_bucket.name})` : ''}
                    </td>
                    <td>1</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                        <button className="ph_view_history_btn" onClick={() => this.viewHistory('ticket', ticket.id)}>
                            View History
                        </button>
                    </td>
                </tr>
            ))
        }

        if (child.type === 'pass') {
            return child.items.map((pass, i) => (
                <tr key={pass.id || i} className="ph_child_row">
                    <td className="ph_child_id">{this.val(pass.id)}</td>
                    <td>{pass.created_at ? `${moment(pass.created_at).tz("US/Mountain").format('MM/DD/YYYY h:mm A')} MT` : '-'}</td>
                    <td>{pass.pass_bucket ? pass.pass_bucket.name : '-'}</td>
                    <td>1</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                        <button className="ph_view_history_btn" onClick={() => this.viewHistory('pass', pass.id)}>
                            View History
                        </button>
                    </td>
                </tr>
            ))
        }

        return null
    }

    getProducts = (order) => {
        const products = [];
      
        // Group tickets by event.id
        const ticketMap = {};
        (order.tickets || []).forEach((ticket) => {
          const id = ticket.event.id;
      
          if (!ticketMap[id]) {
            ticketMap[id] = {
              name: `SFT: ${ticket.event.name}`,
              count: 0,
            };
          }
      
          ticketMap[id].count++;
        });
      
        // Group passes by pass_bucket.id
        const passMap = {};
        (order.passes || []).forEach((pass) => {
          const id = pass.pass_bucket.id;
      
          if (!passMap[id]) {
            passMap[id] = {
              name: pass.pass_bucket.name,
              count: 0,
            };
          }
      
          passMap[id].count++;
        });
      
        Object.values(ticketMap).forEach(({ name, count }) => {
          products.push(count > 1 ? `${name} (x${count})` : name);
        });
      
        Object.values(passMap).forEach(({ name, count }) => {
          products.push(count > 1 ? `${name} (x${count})` : name);
        });
      
        return <div style={{ whiteSpace: "pre-line" }}>
        {products.join("\n")}
      </div>
      };

    render() {
        const { purchaseList } = this.props
        const { expandedRows, viewHistoryPopup, historyData, historyLoading, refreshing } = this.state
        return (
            <>
                <div className="user_popup active">
                    <span className="popup_overlay" onClick={this.props.CloseModal}></span>
                    <div className="editaccount sundance_popup_detail box_shadow">
                        <div className="bg_white">
                            <div className="form_header text_center">
                                <div className="d_flex d_flex_justify_center d_flex_align_center">
                                    <h4 className="form_heading">Purchase History</h4>
                                </div>
                                <span className={`ph_refresh_btn pointer${refreshing ? ' ph_refresh_spinning' : ''}`} onClick={this.handleRefresh} title="Refresh">
                                    <img src={refresh} alt="Refresh" />
                                </span>
                            <span className="closePopup pointer" onClick={this.props.CloseModal}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.181396L5.94897 4.55825L1.70697 0.181396L0.292969 1.64035L4.53497 6.0172L0.292969 10.394L1.70697 11.853L5.94897 7.47615L10.192 11.853L11.606 10.394L7.36397 6.0172L11.606 1.64035L10.192 0.181396Z" fill="white" />
                                    </svg>
                                </span>
                            </div>

                            <div className="recipt_modal">
                                {refreshing && (
                                    <div className="ph_content_loader">
                                        <img src={LoaderSvg} alt="loading" />
                                    </div>
                                )}
                                <div className={`purchase_history_wrap${refreshing ? ' ph_wrap_loading' : ''}`}>
                                    {purchaseList && purchaseList.length > 0 ? (
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Date / Time</th>
                                                    <th>Products</th>
                                                    <th>Quantity</th>
                                                    <th>Discounts Applied</th>
                                                    <th>Payment Method</th>
                                                    <th>Refund Status</th>
                                                    <th>Receipt</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {purchaseList.map((item, index) => {
                                                    const child = this.getChildItems(item)
                                                    const hasChildren = child && child.items.length > 0
                                                    const isExpanded = expandedRows[item.id]
                                                    return (
                                                        <React.Fragment key={item.id || index}>
                                                            <tr>
                                                                <td>
                                                                    {hasChildren && (
                                                                        <span
                                                                            className="ph_toggle_btn"
                                                                            onClick={() => this.toggleRow(item.id)}
                                                                        >
                                                                            {isExpanded ? '▼' : '▶'}
                                                                        </span>
                                                                    )}
                                                                    {this.val(item.id)}
                                                                </td>
                                                                <td>{item.created_at ? `${moment(item.created_at).tz("US/Mountain").format('MM/DD/YYYY h:mm A')} MT` : '-'}</td>
                                                                <td>{this.getProducts(item)}</td>
                                                                <td>{item.quantity !== undefined && item.quantity !== null ? item.quantity : '-'}</td>
                                                                <td>{this.val(item.coupon)}</td>
                                                                <td>{this.val(item.payment_method_summary)}</td>
                                                                <td>{item.refunded_at ? `${moment(item.refunded_at).tz("US/Mountain").format('MM/DD/YYYY h:mm A')} MT` : '-'}</td>
                                                                <td>
                                                                    {item.order_receipt_pdf_path
                                                                        ? <a href={'https://api.eventive.org/' + item.order_receipt_pdf_path} target="_blank" rel="noopener noreferrer">View Receipt</a>
                                                                        : '-'}
                                                                </td>
                                                            </tr>
                                                            {isExpanded && this.renderChildRows(item)}
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p className="no_purchase">No purchase history found.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {viewHistoryPopup && (
                    <div className="user_popup active ph_history_popup_overlay">
                        <span className="popup_overlay" onClick={this.closeHistoryPopup}></span>
                        <div className="sundance_popup_detail box_shadow bg_white ph_history_popup">
                            <div className="form_header text_center">
                                <div className="d_flex d_flex_justify_center d_flex_align_center">
                                    <h4 className="form_heading">View History</h4>
                                </div>
                                <span className="closePopup pointer" onClick={this.closeHistoryPopup}>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.192 0.181396L5.94897 4.55825L1.70697 0.181396L0.292969 1.64035L4.53497 6.0172L0.292969 10.394L1.70697 11.853L5.94897 7.47615L10.192 11.853L11.606 10.394L7.36397 6.0172L11.606 1.64035L10.192 0.181396Z" fill="white" />
                                    </svg>
                                </span>
                            </div>
                            <div className="recipt_modal">
                                <div className="purchase_history_wrap">
                                    {historyLoading
                                        ? <p className="no_purchase">Loading...</p>
                                        : this.renderHistoryRows(historyData || [])
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
}
